<ion-content id="ios-installer">
  <div class="modalNavHead">
    <div class="headerText">
      Installation Cigaro iOS
    </div>
    <ion-icon name="close-circle-outline" (click)="close()"></ion-icon>
  </div>
  <div>
    <ion-list>
      <ion-item lines="none">
        <ion-label class="ion-text-wrap">
        1. {{'ios-install.push' | translate}} <i>{{'ios-install.share_button' | translate}}</i> {{'ios-install.in' | translate}} <b>Safari</b>
        <span class="littlejoe">({{'ios-install.littlejoe' | translate}})</span>
        </ion-label>
      </ion-item>
      <ion-item lines="none">
        <img src="./assets/ios_install/ios_install1.jpg">
      </ion-item>
      <ion-item lines="none">
        <ion-label class="ion-text-wrap">
        2. {{'ios-install.scroll-down' | translate}} -> {{'ios-install.push' | translate}} <i>{{'ios-install.add-home' | translate}}</i>
        </ion-label>
      </ion-item>
        <ion-item lines="none">

          <img src="./assets/ios_install/ios_install2_de.jpg" *ngIf="language==='de'">
          <img src="./assets/ios_install/ios_install2_en.jpg" *ngIf="language!=='de'">
        </ion-item>
    </ion-list>
    

  </div>
</ion-content>